import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    {/* Arrow pointing down */}
    <path
      d="M15 4 L15 18 M15 18 L10 13 M15 18 L20 13"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Line underneath */}
    <path
      d="M8 24 L22 24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </React.Fragment>,
  'Download'
)
